import type { TBoard } from '../types';
import { COLS, EMPTY_CELL, ROWS } from '../constants';

export function createEmptyBoard(): TBoard {
  return Array.from({ length: ROWS }, () =>
    Array.from({ length: COLS }, () => EMPTY_CELL),
  );
}
